
import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { blogPosts, isPublished } from "./data/blogPosts";
import { Button } from "./lp2/ui/button.tsx";
import { ArrowLeft } from "lucide-react";
import Navigation from "./lp2/Navigation";
import Footer from "./lp2/Footer";
import { STANDARD_TITEL } from "./seitenTitel";

const BlogPost = () => {
  const { postId } = useParams();
  // Neue Artikel haben einen sprechenden Slug, die alten nur ihre Nummer.
  const post = blogPosts.find(
    (p) => (p.slug === postId || p.id === parseInt(postId || "0", 10)) && isPublished(p)
  );

  // Titel, Beschreibung und canonical pro Artikel. index.html setzt bewusst
  // keinen canonical-Tag: sie wird fuer jede Route ausgeliefert, ein fester
  // Wert wuerde jeden Artikel zur Kopie der Startseite erklaeren.
  useEffect(() => {
    if (!post) return undefined;
    const description = document.querySelector('meta[name="description"]');
    // Nicht document.title sichern: die vorgerenderte Datei bringt bereits den
    // Artikeltitel mit, den wiederherzustellen hiesse, ihn auf der naechsten
    // Seite stehen zu lassen.
    const vorher = { description: description?.getAttribute("content") };
    document.title = post.metaTitle || post.title;
    if (description && post.metaDescription) description.setAttribute("content", post.metaDescription);
    // Die vorgerenderte Datei bringt bereits einen canonical mit
    // (client/scripts/prerender-blog.js). Dann den vorhandenen aendern statt
    // einen zweiten anzuhaengen. Nur beim Wechsel innerhalb der Anwendung,
    // wo kein neues HTML geladen wird, legen wir selbst einen an.
    const vorhanden = document.querySelector('link[rel="canonical"]');
    const canonical = vorhanden || document.createElement("link");
    if (!vorhanden) {
      canonical.rel = "canonical";
      document.head.appendChild(canonical);
    }
    canonical.href = `https://www.esgehtmirgut.ch/blog/${post.slug || post.id}`;
    return () => {
      document.title = STANDARD_TITEL;
      if (description && vorher.description) description.setAttribute("content", vorher.description);
      // Beim Verlassen auf die Adresse zeigen lassen, auf der wir gelandet
      // sind – der Artikelwert waere dort falsch.
      if (vorhanden) canonical.href = window.location.origin + window.location.pathname;
      else canonical.remove();
    };
  }, [post]);
  if (!post) {
    return (
      <div className="min-h-screen">
        <Navigation />
        <div className="max-w-4xl mx-auto px-4 py-20 text-center">
          <h1 className="text-2xl font-bold text-gray-900 mb-4">Artikel nicht gefunden</h1>
          <Link to="/blog">
            <Button className="bg-blue-600 hover:bg-blue-700 text-white">
              Zurück zum Blog
            </Button>
          </Link>
        </div>
        <Footer />
      </div>
    );
  }

  return (
    <div className="min-h-screen">
      <Navigation />
      
      <article className="py-20 px-4">
        <div className="max-w-4xl mx-auto">
          <div className="mb-8">
            <Link to="/blog">
              <Button variant="outline" className="mb-6">
                <ArrowLeft className="w-4 h-4 mr-2" />
                Zurück zum Blog
              </Button>
            </Link>
            
            {post.image && (
              <div className="aspect-video bg-gray-200 rounded-lg overflow-hidden mb-8">
                <img
                  src={post.image}
                  alt={post.imageAlt || post.title}
                  className="w-full h-full object-cover"
                />
              </div>
            )}
            
            <h1 className="text-3xl md:text-4xl font-bold text-gray-900 mb-4">
              {post.title}
            </h1>
            {post.date && (
              <p className="text-gray-500">
                Philip Hanke ·{" "}
                {new Date(post.date).toLocaleDateString("de-CH", {
                  day: "numeric", month: "long", year: "numeric",
                })}
              </p>
            )}
          </div>

          <div 
            className="blog-content text-lg"
            dangerouslySetInnerHTML={{ __html: post.content }}
          />

          <div className="mt-12 rounded-lg border border-blue-100 bg-blue-50 p-6 md:p-8">

            <h2 className="text-xl md:text-2xl font-bold text-gray-900 mb-2">

              Jeden Tag wissen, dass es Ihren Eltern gut geht

            </h2>

            <p className="text-gray-700 mb-5">

              Eine kurze Nachricht am Morgen. Kommt keine Antwort, erfahren Sie es.

              14 Tage kostenlos, ohne Kreditkarte.

            </p>

            <Link to="/register?fuer=angehoeriger">

              <Button className="bg-blue-600 hover:bg-blue-700 text-white">

                Für einen Angehörigen einrichten

              </Button>

            </Link>

          </div>


          <div className="mt-12 pt-8 border-t border-gray-200">
            <div className="flex justify-between items-center">
              <Link to="/blog">
                <Button variant="outline">
                  <ArrowLeft className="w-4 h-4 mr-2" />
                  Alle Artikel
                </Button>
              </Link>
            </div>
          </div>
        </div>
      </article>

      <Footer />
    </div>
  );
};

export default BlogPost;
